export interface Operator {
	Id: number | null;
	Name: string;
	ClockNumber: string;
	Active: boolean;
}

export const OPERATOR_INITIAL_VALUES: Operator = {
	Id: null,
	Name: "",
	ClockNumber: "",
	Active: true,
};
